import { render, staticRenderFns } from "./iconPillButton.vue?vue&type=template&id=d406374e&scoped=true&"
import script from "./iconPillButton.vue?vue&type=script&lang=ts&"
export * from "./iconPillButton.vue?vue&type=script&lang=ts&"
import style0 from "./iconPillButton.vue?vue&type=style&index=0&id=d406374e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d406374e",
  null
  
)

export default component.exports